
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const options: any = {
    feedback: '意见反馈',
    include: '请求收录',
    data: '数据纠错'
}

const statusOptions = {
    Treated: {
        key: 1,
        label: '已处理'
    },
    unTreated: {
        key: 0,
        label: '未处理'
    }
}

@Component({
    name: 'release-detail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private type = ''
    private detail = {
        status: 0,
        title: '',
        user: { name: '', id: '' },
        type: { name: '' }
    }
    private statusOptions = statusOptions
    private requestMap: any = new Map([
        ['feedback', CommonService.getFeedbackDetail],
        ['include', CommonService.getIncludeRequestDetail],
        ['data', CommonService.getDataCorrectionDetail]
    ])
    private updateRequestMap: any = new Map<string, any>([
        ['feedback', CommonService.updateFeedbackDetail],
        ['include', CommonService.updateIncludeRequestDetail],
        ['data', CommonService.updateDataCorrectionDetail]
    ])

    get isInclude() {
        return this.type === 'include'
    }

    private created() {
        this.detailId = this.$route.params.id
        this.type = this.$route.params.type
        this.$title('Loading | 详情页 - 庖丁')
    }

    private async mounted() {
        this.isLoading = true
        await this.getDetail()
        this.isLoading = false
    }

    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        const result = await this.requestMap.get(this.type)(params)
        if (result.status === 200) {
            this.detail = result.data
            this.$title('Loading | 详情页 - 庖丁')
            this.$title(`${options[this.type]} | 反馈详情 - 庖丁`)
        }
    }

    private async onStatusSelect(status: any) {
        const params = {
            id: +this.detailId,
            status
        }
        const result = await this.updateRequestMap.get(this.type)(params)
        if (result.status === 200) {
            return this.$message({ type: 'success', message: '更改成功!' })
        }
        return this.$message.error(result.message || '设置失败')
    }
}
